import React from 'react'
import { Button as ReactstrapButton } from 'reactstrap'
import PropTypes from 'prop-types'

const Button = ({text, ...props}) => {
  return (
    <ReactstrapButton {...props}>{text}</ReactstrapButton>
  )
}

Button.propTypes = {
  text: PropTypes.any
}

export default Button